const userAgent = navigator.userAgent;

window.isInternetExplorer = (
	userAgent.indexOf('MSIE ') > -1 ||
	userAgent.indexOf('Trident') > -1
);

if(window.isInternetExplorer) {
	document.documentElement.className += ' is-internet-explorer';
}
